import * as React from 'react'
import { Grid, TextField } from '@material-ui/core'
import { t } from 'ttag'
import { ROUTES } from '../../common/Routes/routePaths'
import { Button } from '../../components/Button/Button'
import { ButtonGroup } from '../../components/ButtonGroup/ButtonGroup'
import { Card } from '../../components/Card/Card'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import { ResetPassword$Request, UserProfileDto } from '../../services/api.types'

export interface IResetPasswordProps {
  authenticated: boolean
  resetPasswordInProgress: boolean
  userDto: UserProfileDto
  resetPassword(payload: ResetPassword$Request): void
}

export interface IForgotPasswordState {
  [key: string]: string
}

export class ResetPassword extends React.Component<IResetPasswordProps, IForgotPasswordState> {
  state = { newPassword: '' }

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target
    this.setState({ [name]: value })
  }

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    this.props.resetPassword(this.state)
  }

  render() {
    return (
      <Card className="pt-12">
        <NotificationsWrapper />
        <Grid container={true} direction="column" alignItems="flex-start">
          <Grid item={true} xs={12} sm={10} lg={4}>
            <form onSubmit={this.onSubmit}>
              <h1>{t`Reset password`}</h1>

              <TextField
                label={t`New password`}
                type="password"
                name="newPassword"
                fullWidth={true}
                onChange={this.handleInputChange}
                margin="normal"
              />

              <ButtonGroup>
                <Button text={t`Save new Password`} type="submit" />
                <Button text={t`Cancel`} type="button" link={true} url={ROUTES.LOGIN.to} />
              </ButtonGroup>
            </form>
          </Grid>
        </Grid>
      </Card>
    )
  }
}
